import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageHelper } from '@diktup/frontend/helpers';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private storageHelper: StorageHelper, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newRequest: any;
    const token = this.storageHelper.getData('token');
    if (token) {
      newRequest = {
        setHeaders: {
          app: 'SIFCA',
          platform: 'web',
          Authorization: 'Bearer ' + token,
        },
      };
    } else {
      newRequest = {
        setHeaders: {
          app: 'SIFCA',
          platform: 'web',
        },
      };
    }

    // Response
    return next.handle(req.clone(newRequest)).pipe(
      catchError((error) => {
        // Catch "401 Unauthorized" responses
        // if ( error instanceof HttpErrorResponse && error.status === 401 )
        // {
        //     // Sign out
        //     this._authService.signOut();

        //     // Reload the app
        //     location.reload();
        // }
        if (error instanceof HttpErrorResponse) {
          if (error.error instanceof ErrorEvent) {
            console.error('Error Event');
          } else {
            if (error.status === 401) {
              // Sign out
              localStorage.removeItem('token');
              // Reload the app
              location.reload();
            }
            if (error.status === 500) {
              this.router.navigateByUrl('/pages/error/500');
            }
          }
        } else {
          console.error('some thing else happened');
        }
        return throwError(() => new Error(error));
      }),
    );
  }
}
